/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Upload_TitleInputs */

const en_features_upload_title = /** @type {(inputs: Features_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening supports all kinds of files: research papers, PDFs, books, websites, emails, EPUB, MOBI, and more!`)
};

const es_features_upload_title = /** @type {(inputs: Features_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening soporta todo tipo de archivos: artículos de investigación, PDFs, libros, sitios web, correos electrónicos, EPUB, MOBI y más.`)
};

/**
* | output |
* | --- |
* | "Listening supports all kinds of files: research papers, PDFs, books, websites, emails, EPUB, MOBI, and more!" |
*
* @param {Features_Upload_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_upload_title = /** @type {((inputs?: Features_Upload_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Upload_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_upload_title(inputs)
	return en_features_upload_title(inputs)
});